import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b0a6d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no_data"
}

import Live from '@/components/organisms/Live'
import { Camera } from '@/@types/typescript-axios'


type PropsType = {
  cameraDetail: Camera
  updateInterval: number
  displaySize: { width: number; height: number }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiVideoLive',
  props: {
    cameraDetail: null,
    updateInterval: null,
    displaySize: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!__props.cameraDetail.use_nolive)
    ? (_openBlock(), _createBlock(_unref(Live), {
        key: 0,
        class: "live",
        "camera-detail": __props.cameraDetail,
        "display-size": __props.displaySize,
        "update-interval": __props.updateInterval
      }, null, 8, ["camera-detail", "display-size", "update-interval"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('videos.not_support')), 1)
      ]))
}
}

})